import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { projectHelper, userHelper } from '../../common/src/helpers'
import { AMPLITUDE_ACTION_TYPES, dispatchEvent } from '../../common/src/eventTracking/amplitudeEvents'
import { useOrganizedUsersOptions } from '../../hooks/useUsersOption'
import { UserPanel } from '../users/panels/UserPanel'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../common/src/hooks/usersHooks'

export const FollowersPanel = memo(({ project, onChange, onDismiss, ...rest }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const me = useMe()
  
  const options = useOrganizedUsersOptions({
    project,
    minusUsers: [], // No users to exclude for adding followers
  })

  const onSelectUserClosing = useCallback(
    user => {
      const email = user ? userHelper.getEmail(user) : ''
      dispatch(dispatchEvent(AMPLITUDE_ACTION_TYPES.ADD_FOLLOWER))
      onChange(email)
      onDismiss()
    },
    [onChange, onDismiss, dispatch]
  )

  // Check if project is restricted and current user is not an admin
  const isProjectRestricted = projectHelper.isRestricted(project)
  const isCurrentUserAdmin = projectHelper.isEffectiveAdmin(project, me)
  const shouldHideExternalAccess = isProjectRestricted && !isCurrentUserAdmin

  return (
    <UserPanel
      headerText={t('item.multiple_selection.add_followers')}
      onDismiss={onDismiss}
      user={null} // No current user selected
      options={options}
      onSelectUser={onSelectUserClosing}
      selectedUserHeader={t('users.add_as_follower')}
      textFieldPlaceholder={t('item.multiple_selection.add_followers_placeholder')}
      invitationIconProps={{ title: t('item.multiple_selection.add_followers_tooltip') }}
      clearText={t('users.cancel')}
      project={project}
      hideEmailInput={shouldHideExternalAccess}
      hideUserGroups={shouldHideExternalAccess}
      {...rest}
    />
  )
})